// extracted by mini-css-extract-plugin
export var divider = "_1c-0";
export var dividerText = "_1c-1";